
import { logger } from '@/utils/logger';
import { getSecurityDemoContent } from './demoContent/securityContent';
import { fetchContentFromUrl } from './fetch/contentFetcher';

/**
 * Fetches article content fresh every time (no caching)
 */
export async function fetchArticleContent(url: string): Promise<string> {
  console.log(`🔍 FAQ Expert: Fetching fresh article content for URL: ${url}`);
  
  try {
    // Fetch fresh content every time - no fallbacks to avoid generic content
    const content = await fetchContentFromUrl(url);
    
    // Additional validation to ensure content quality
    if (content.length < 200) {
      throw new Error(`Content too short for quality FAQ generation (${content.length} chars). Need at least 200 characters.`);
    }
    
    // Log content characteristics for debugging
    const wordCount = content.split(/\s+/).length;
    console.log(`✅ FAQ Expert: Content validation passed - ${content.length} chars, ~${wordCount} words`);
    
    return content;
    
  } catch (error) {
    console.error('❌ FAQ Expert: Error fetching article content:', error);
    logger.error('Failed to fetch article content', error as Error, {
      context: { url, component: 'faqArticleFetcher' }
    });
    
    // Don't use fallback content - this was causing generic FAQs
    // Let the error bubble up so user gets proper feedback
    throw error;
  }
}
